/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'company-hub.card-extensions.card-config.background-color-field.title': '背景顏色',
  'company-hub.card-extensions.card-config.text-color-field.title': '文字顏色',
  'company-hub.card-extensions.large-card.large-card-v1.empty-state.title-placeholder': '為卡片提供標題',
  'company-hub.card-extensions.large-card.large-card-v2.empty-state.title-placeholder': '為卡片提供標題',
  'company-hub.card-extensions.medium-card.medium-card-v1.empty-state.title-placeholder': '為卡片提供標題',
  'company-hub.card-extensions.medium-card.medium-card-v2.empty-state.title-placeholder': '為卡片提供標題',
  'company-hub.card-extensions.small-card.small-card-v1.empty-state.title-placeholder': '為卡片提供標題',
  'company-hub.cards-extension.ai-disclaimer.disclaimer-message': 'AI 生成的內容',
  'company-hub.cards-extension.autoscroll-wrapper.pause': '暫停',
  'company-hub.cards-extension.autoscroll-wrapper.play': '播放',
  'company-hub.cards-extension.card-config-panel.content-section.display-options.icon-toggle-label': '圖示',
  'company-hub.cards-extension.card-config-panel.content-section.display-options.social-stats-toggle-label': '社群統計',
  'company-hub.cards-extension.card.background.color': '背景顏色',
  'company-hub.cards-extension.card.color-contrast.fail': '您的文字和背景顏色搭配無法凸顯內容。',
  'company-hub.cards-extension.card.color-contrast.success': '您的文字和背景顏色搭配可以凸顯內容。',
  'company-hub.cards-extension.card.text.color': '文字顏色',
  'company-hub.cards-extension.cards.config-panel.border.color': '邊框顏色',
  'company-hub.cards-extension.cards.hub-element.description': '顯示連結、圖片等等',
  'company-hub.cards-extension.cards.hub-element.title': '卡片',
  'company-hub.cards-extension.config-panel.link.field.label': '連結',
  'company-hub.cards-extension.config-panel.render-variant.dynamic': '<p>動態</p>',
  'company-hub.cards-extension.config-panel.render-variant.dynamic.description':
    '使用<strong>動態</strong>卡片來建置篩選條件，立即產生一組自動更新的卡片。',
  'company-hub.cards-extension.config-panel.render-variant.manual': '<p>手動</p>',
  'company-hub.cards-extension.config-panel.render-variant.manual.description':
    '使用<strong>手動</strong>卡片，將特定連結、文字或圖片新增至中心。',
  'company-hub.cards-extension.description.field.label': '描述',
  'company-hub.cards-extension.dynamic-card-empty-state.no-filter-title': '新增篩選條件以填入卡片。',
  'company-hub.cards-extension.dynamic-card-empty-state.no-results-title': '還沒有任何內容可以顯示。請稍後再返回查看。',
  'company-hub.cards-extension.link-cards-config-panel.cards.content.display-options.title': '顯示選項',
  'company-hub.cards-extension.link-cards-config-panel.cards.error.invalid-list': '新增卡片',
  'company-hub.cards-extension.link-cards-config-panel.cards.style.general.title': '一般',
  'company-hub.cards-extension.link-cards-config-panel.cards.styles-tab.layouts.fixed-image-height.description':
    '所有卡片上的圖片大小都相同',
  'company-hub.cards-extension.link-cards-config-panel.cards.styles-tab.layouts.fixed-image-height.label':
    '固定圖片高度',
  'company-hub.cards-extension.link-cards-config-panel.cards.styles-tab.layouts.flexible-image-height.description':
    '圖片大小會因應文字數量而變動',
  'company-hub.cards-extension.link-cards-config-panel.cards.styles-tab.layouts.flexible-image-height.label':
    '彈性的圖片高度',
  'company-hub.cards-extension.link-cards-config-panel.cards.styles-tab.layouts.title': '版面配置',
  'company-hub.cards-extension.link-cards-config-panel.cards.text.description': '顯示連結、圖片等。{link}',
  'company-hub.cards-extension.link-cards-config-panel.cards.text.description-without-support-link':
    '顯示連結、圖片等。',
  'company-hub.cards-extension.link-cards-config-panel.cards.text.description.link': '進一步了解卡片。',
  'company-hub.cards-extension.link-cards-config-panel.content-tab.label': '內容',
  'company-hub.cards-extension.link-cards-config-panel.size-field.drop-down.item.large.label': '大',
  'company-hub.cards-extension.link-cards-config-panel.size-field.drop-down.item.medium.label': '中',
  'company-hub.cards-extension.link-cards-config-panel.size-field.drop-down.item.small.label': '小',
  'company-hub.cards-extension.link-cards-config-panel.size-text-label': '大小',
  'company-hub.cards-extension.link-cards-config-panel.styles-tab.label': '樣式',
  'company-hub.cards-extension.link-cards-config-panel.styles.autoscroll-label': '自動捲動',
  'company-hub.cards-extension.link-cards-config-panel.styles.autoscroll-tooltip-content':
    '當您退出編輯模式時，畫面中容納不下的卡片將會開始捲動',
  'company-hub.cards-extension.link-cards-config-panel.styles.display-as-label': '顯示為',
  'company-hub.cards-extension.link-cards-config-panel.styles.padding-label': '填補',
  'company-hub.cards-extension.link-cards-config-panel.styles.row-description': '卡片在一列中滾動',
  'company-hub.cards-extension.link-cards-config-panel.styles.row-label': '列',
  'company-hub.cards-extension.link-cards-config-panel.styles.stacked-description': '卡片換到新行',
  'company-hub.cards-extension.link-cards-config-panel.styles.stacked-label': '堆疊',
  'company-hub.cards-extension.link-cards-config-panel.title-text-label': '卡片',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.ai-description.label-v2': '描述',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.avatar.label': '顯示負責人',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.avatar.label-v2': '內容負責人',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.info-icon-label':
    '選擇哪些 Confluence 使用者群組會看到您的卡片',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.label.label-v2': '標籤',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.new-lozenge-label': '新增',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.new-lozenge-label-v2': '新增',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.publish-date.label': '顯示上次更新時間',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.publish-date.label-v2': '上次更新時間',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.segmentation.label': '選擇目標受眾',
  'company-hub.cards-extension.link-cards-config-panel.type-field.toggle.segmentation.label-v2': '目標受眾',
  'company-hub.cards-extension.link-cards-content.card-components.build-dynamic-cards': '建置動態卡片',
  'company-hub.cards-extension.link-cards-content.card-components.card-count-label': '卡片數目',
  'company-hub.cards-extension.link-cards-content.card-components.dynamic-content-modal-dialog.cancel-button': '取消',
  'company-hub.cards-extension.link-cards-content.card-components.dynamic-content-modal-dialog.clear-all-filters-button':
    '清除所有篩選條件',
  'company-hub.cards-extension.link-cards-content.card-components.dynamic-content-modal-dialog.confirm-button': '確認',
  'company-hub.cards-extension.link-cards-content.card-components.dynamic-content-modal-dialog.header': '建置動態卡片',
  'company-hub.cards-extension.link-cards-content.card-components.dynamic-content-modal-dialog.header-subtext':
    '建立一組自訂的自動填入卡片，以顯示最新資訊。使用篩選條件，按標籤、空間、負責人等等選取卡片內容。',
  'company-hub.cards-extension.link-cards-content.card-components.error-states.no-dynamic-cards.header':
    '尚未有動態卡片',
  'company-hub.cards-extension.link-cards-content.card-components.error-states.no-results.description':
    '內容不存在或在新增此連結後可能已變更',
  'company-hub.cards-extension.link-cards-content.card-components.error-states.no-results.header':
    '我們無法向您顯示此內容',
  'company-hub.cards-extension.link-cards-content.card-components.error-states.restricted-content.button.label':
    '要求存取權',
  'company-hub.cards-extension.link-cards-content.card-components.error-states.restricted-content.description':
    '您需要取得要求存取權或嘗試其他帳戶，才能查看此預覽',
  'company-hub.cards-extension.link-cards-content.card-components.error-states.restricted-content.header':
    '受限制的內容',
  'company-hub.cards-extension.link-cards-content.card-components.view-current-filters': '檢視目前的篩選條件',
  'company-hub.cards-extension.manifest.macro-description': '將連結顯示為卡片',
  'company-hub.cards-extension.manifest.macro-title': '卡片',
  'company-hub.cards-extension.recommended.field.label': '(推薦)',
  'company-hub.cards-extension.row-orientation.next': '下一個',
  'company-hub.cards-extension.row-orientation.previous': '上一個',
  'company-hub.cards-extension.smart-card.empty-state.placeholder-title': '新增標題',
  'company-hub.cards-extension.smart-card.no-results-title': '這裡還沒有任何內容可以顯示。請稍後再返回查看。',
  'company-hub.cards-extension.title.field.label': '標題',
};
